module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"targetTitle":"週間売上目標 - 前年度実績","totalSales1":"累計実績","totalSales2":" ","monthlySalesTarget1":"今月の売上目標","monthlySalesTarget2":" ","lastYearSales1":"前年同月の売上高","lastYearSales2":" ","remaining":"達成まで","progress":"進捗"}}')
  delete Component.options._Ctor
}
